import { assign, sendParent, setup } from 'xstate';
import { publishTaxRulesActor } from './taxruleset.actors';
import type { TaxrulesetEvent } from './events';
import type { PublishTaxRulesInput } from '@/lib/gql/__generated__/graphql';

type TaxrulesetContext = { input: PublishTaxRulesInput; error?: string };

export const taxrulesetMachine = setup({
  types: {
    context: {} as TaxrulesetContext,
    events: {} as TaxrulesetEvent,
  },
  actors: { publishTaxRulesActor },
  actions: {
    rememberInput: assign(({ event }) => ({
      input: {
        taxRuleSetId: crypto.randomUUID(),
        taxYear: event.taxYear,
        ruleVersion: event.ruleVersion,
      },
      error: undefined,
    })),
    announceSuccess: sendParent(({ context }) => ({
      type: 'taxruleset.published',
      taxRuleSetId: context.input.taxRuleSetId,
    })),
    toastSuccess: sendParent({ type: 'ui.toast.push', toast: { title: 'Tax rules published', tone: 'success' } }),
    toastError: sendParent({
      type: 'ui.toast.push',
      toast: { title: 'Tax rules could not be published', tone: 'error' },
    }),
  },
}).createMachine({
  id: 'taxruleset',
  initial: 'idle',
  context: { input: { taxRuleSetId: '', taxYear: 0, ruleVersion: '' } },
  states: {
    idle: { on: { 'taxruleset.publish': { target: 'publishing', actions: 'rememberInput' } } },
    publishing: {
      invoke: {
        src: 'publishTaxRulesActor',
        input: ({ context }) => context.input,
        onDone: { target: 'idle', actions: ['toastSuccess', 'announceSuccess'] },
        onError: { target: 'error', actions: 'toastError' },
      },
    },
    error: { on: { 'taxruleset.publish': { target: 'publishing', actions: 'rememberInput' } } },
  },
});
